import React from 'react';
import { ShieldCheck } from 'lucide-react';
import ModulePageLayout, { Section, FeatureGrid, Steps } from '../../components/ModulePageLayout';
import { getModule } from '../../data/modules';

export default function CreditProtectPage() {
  const module = getModule('credit-protect')!;
  return (
    <ModulePageLayout module={module} Icon={ShieldCheck}>
      <Section title="Insurance-Like Protection Against Credit Events">
        <p className="text-gray-700 leading-relaxed">
          Credit Protect guards against overdrafts, unexpected expenses, and credit score drops. Choose a
          Secured or Unsecured plan with defined coverage amounts, limits, fees, and terms — pause or cancel
          anytime.
        </p>
      </Section>

      <Section title="What's Covered">
        <FeatureGrid
          items={[
            { title: 'Overdraft Protection', body: 'Automatic coverage when your HCA balance goes negative — we record the amount covered and the fee charged.' },
            { title: 'Borrow Requests', body: 'Emergency credit backed by your plan coverage, separate from your standard credit line.' },
            { title: 'Expense Tracking', body: 'Built-in expense logging helps you monitor spending patterns that affect your credit health.' },
            { title: 'Unified Credit Reports', body: 'We pull and store reports from all three bureaus, giving you one consolidated view.' },
          ]}
        />
      </Section>

      <Section title="Filing a Claim">
        <Steps
          items={[
            'A covered event occurs — an overdraft, an unexpected expense, or a credit-impacting incident.',
            'You file a claim through the app describing the event.',
            'The claim enters review: Pending → Processed, with a documented outcome either way.',
            'Approved claims are paid out or applied directly against the covered cost.',
          ]}
        />
      </Section>
    </ModulePageLayout>
  );
}
